module.exports = __webpack_public_path__ + "static/media/ionic.fede5c3a.svg";